/*-------------------------------------------------------------------
Author: Justin Herrera <jherrera@awareweb.com>
Date: July 15, 2014
-------------------------------------------------------------------*/

jQuery(document).ready(function ($) {
    //-- Menu Toggle Script
    $("#menu-toggle").click(function (e) {
        e.preventDefault();
        $("#wrapper").toggleClass("toggled");
    });

    /* Fixed nav top */
    var navHeight = $('.navbar.navbar-fixed-top').outerHeight(true);
    $('body').css("padding-top", navHeight);

    //jump menu and sidenav scrollspy
    //Initiate smoothscroll
    if ($("#top").length) {
        $('body').scrollspy({ target: '#header', offset: navHeight });
        smoothScroll.init({
            offset: navHeight - 1
        });
    }

    //---------------------------------------------------------------
    // Navigation + Megamenu
    //---------------------------------------------------------------
    // Sticky Nav
    $('.main-nav').affix({
        offset: {
            top: $('#top').height()
        }
    });
    // Mobile Menu
    $('#mobile_navigation').mmenu({ position: 'right' });

    // Mobile Search Drawer
    $('#trigger_search').on('click', function (e) {
        var oThis = $(this),
            oTarget = $('#navigation li.search');

        // Close/Open Drawer
        oTarget.toggleClass('mobile_open');

        e.preventDefault();
    });

    // Search
    $('#navigation li.search .btn').on('click', function (e) {
        var q = $('#navigation li.search input').val();
        if (q.length > 0) {
            var contentSearchOnly = $(this).attr('content-search-only');
            if (contentSearchOnly != null && contentSearchOnly == 'true') {
                var url = $(this).attr('data-url');
                if (url != null && url != '') {
                    url += "#q=" + q;
                    document.location = url;
                }
            } else {
                // Site search
                var url1 = $('#navigation li a.search1').data('url');
                if (url1.length > 0) {
                    var path = url1 + "#q=" + q;
                    $('#navigation li a.search1').attr('href', path);
                }
                // Parts search
                var url2 = $('#navigation li a.search2').data('url');
                if (url2.length > 0) {
                    var path = url2 + "?SelectedFilterByOption=equipment&SearchText=" + q;
                    $('#navigation li a.search2').attr('href', path);
                }
            }
        }
    });

    // Megamenu
    $('#navigation > li > a').on('click', function (e) {
        var oThis = $(this),
            oParent = oThis.parent(),
            iIndex = $('#navigation > li > a.trigger_megamenu').index(oThis),
            oTarget = $('#megamenu_container .megamenu:eq(' + iIndex + ')');

        // Proceed with Megamenu Items
        if (oThis.hasClass('trigger_megamenu') && oParent.hasClass('open')) {
            oParent.removeClass('open');
            oTarget.removeClass('open');
        } else {
            // Close all other menus
            oParent.siblings().removeClass('open');
            $('#megamenu_container .megamenu').removeClass('open');

            // Open New Megamenu
            if (oThis.hasClass('trigger_megamenu')) {
                oParent.addClass('open');
                oTarget.addClass('open');
            }
        }

        if (!oThis.hasClass('singleLink')) {
            e.preventDefault();
        }
    });

    // Closing Megamenus
    $(window).on('click', function (e) {
        var isMegaMenuOpen = $('#navigation > li.open').length > 0 ? true : false;

        // Close Megamenus if clicking anywhere outside navigation & megamenu container
        if (isMegaMenuOpen && !$.contains($('#navigation')[0], e.target) && !$.contains($('#megamenu_container')[0], e.target)) {
            $('#navigation > li.open > a').trigger('click');
        }
    });

    // Site Search when enter pressed
    $('#navigation li.search input').keyup(function (e) {
        if (e.keyCode == 13) {
            var q = $('#navigation li.search input').val();
            if (q.length > 0) {
                var contentSearchOnly = $('#navigation li.search button').attr('content-search-only');
                if (contentSearchOnly != null && contentSearchOnly == 'true') {
                    var url = $('#navigation li.search button').attr('data-url');
                    if (url != null && url != '') {
                        url += "#q=" + q;
                        document.location = url;
                    }
                }
                else {
                    var url1 = $('#navigation li a.search1').data('url');
                    if (url1.length > 0) {
                        var path = url1 + "#q=" + q;
                        window.location.href = path;
                    }
                }
            }
        }
    });

    // Site Search when enter pressed
    $('#mobile_navigation li.mm-search button').on('click', function (e) {
        var q = $('#mobile_navigation li.mm-search  input').val();
        if (q.length > 0) {
            var url1 = $(this).data('url');
            if (url1.length > 0) {
                var path = url1 + "#q=" + q;
                window.location.href = path;
            }
        }
    });

    /* Activate tooltip */
    $('.tip').tooltip();

    //---------------------------------------------------------------
    // View Model List
    //---------------------------------------------------------------
    $("#viewModelList").on('click', function () {
        $('.pagination li').removeClass('active');
        $('.pagination li:first').addClass('active');
        $('.template-ajax-loading').show();

        $('.modal-model-list-content').load('/parts/modellist/0', function (result) {
            $('.model-list-link').click(function () {
                $('#parts-search').val($(this).attr('id'));
                $('#parts-search').trigger('change');
                $('.modal').modal('hide');
            });
            $('.template-ajax-loading').hide();
            $('.modal-model-list').show();
        });

    });

    $('.page-id').click(function () {
        var pageid = $(this).data('start');

        $('.pagination li').removeClass('active');
        $(this).parent('li').addClass('active');
        $('.template-ajax-loading').show();

        $('.modal-model-list-content').load('/parts/modellist/' + pageid, function (result) {
            $('.model-list-link').click(function () {
                $('#parts-search').val($(this).attr('id'));
                $('#parts-search').trigger('change');
                $('.modal').modal('hide');
            });
            $('.template-ajax-loading').hide();
            $('.modal-model-list').show();
        });
    });

    //---------------------------------------------------------------
    // Part Search within Assembly Drawing
    //---------------------------------------------------------------
    $('#seachAssemblyDrawingPartsForm').submit(function () {
        var oThis = $(this),
			oResultsContainer = $('#part_results_container'), //oThis.siblings('div.toro-results_container'),
			sQuery = oThis.find('.toro-search_query').val(),
            iMYBE = oThis.find('.toro-search_query').data('mybe');

        // Toggle Display of ajax container and result
        if (oResultsContainer.hasClass('hidden')) {
            // First Time Activating
            oResultsContainer.removeClass('hidden');
        } else {
            // Toggle loading and result container
            oResultsContainer.find('div.template-ajax-result, div.template-ajax-loading').toggleClass('hidden');
        }

        $.ajax({
            url: '/parts/partDetails/SearchAssemblyDrawingParts',
            data: { query: sQuery, MYBE: iMYBE },
            dataType: 'json',
            success: function (data) {
                var oDrawings = data.results.drawings,
					iCount = data.results.total,
					oResultList = oResultsContainer.find('tbody.template-results'),
					oResultTemplate = oResultList.find('tr.template-result.hidden');

                // Clear previous results if any
                oResultList.find('tr.template-result:not(.hidden)').remove();

                // Show results container and adjust results range
                oResultsContainer.find('h4 > span').text(iCount);

                // Cycle through the drawings and append to the results table
                $.each(oDrawings, function (i) {
                    var tmpResult = oResultTemplate.clone().removeClass('hidden');

                    // Update Anchor Link and Title
                    tmpResult.find('button.btn').data('image', oDrawings[i].image);
                    tmpResult.find('a.template-title').attr('data-mybe', oDrawings[i].mybe).attr('data-illustrationid', oDrawings[i].illustration_id).attr('data-pageid', oDrawings[i].page_id).text(oDrawings[i].title);

                    // Update Part Number
                    tmpResult.find('td.template-part_number').text(oDrawings[i].part_number);

                    // UPdate Description
                    tmpResult.find('td.template-description').text(oDrawings[i].description);

                    //Update Quantity
                    tmpResult.find('td.template-quantity').text(oDrawings[i].quantity);

                    //Update Price
                    tmpResult.find('span.template-price').html(oDrawings[i].price);

                    tmpResult.appendTo(oResultList);
                });

                // Load Assembly Drawing when clicking component from search results
                $('#part_results_container a').on('click', loadAssemblyDrawing);

                // Toggle loading and result container
                oResultsContainer.find('div.template-ajax-result, div.template-ajax-loading').toggleClass('hidden');
            },
            complete: function () {
                $('.template-result:not(.hidden)').find('button.btn').popover({
                    placement: 'right',
                    trigger: 'click',
                    html: true,
                    content: function () {
                        return '<img src="' + $(this).data('image') + '" />';
                    }
                });
            }

        });

        return false;
    });

    //---------------------------------------------------------------
    // Assembly Drawing Functions
    //---------------------------------------------------------------

    // "Zoom" Function
    $('#assembly_drawing_details').on('click', 'button.btn-primary', function (e) {
        var oThis = $(this),
			oDrawing = $('#assembly_drawing_exploded'),
			oMap = $('#assembly_drawing_map'),
			iZoom = oThis.data('zoom');

        // Swap Disabled States
        oThis.add(oThis.siblings()).toggleClass('disabled');

        // Swap Widths and coordinates
        if (iZoom == 1) {
            oDrawing.attr('width', oDrawing.data('zoom1width'));
            $.each(oMap.find('a'), function (i) {
                var oThis = $(this);
                oThis.attr({ 'style': oThis.data('zoom1x-style') });
            });
        } else {
            oDrawing.removeAttr('width');
            $.each(oMap.find('a'), function (i) {
                var oThis = $(this);
                oThis.attr({ 'style': oThis.data('zoom2x-style') });
            });
        }
    });

    // Highlight Items when Selecting a row in the part table
    $('tbody.assembly-parts-list').on('click', 'tr.template-item', function (e) {
        var oThis = $(this),
			oMap = $('#assembly_drawing_map'),
			iPartNumber = oThis.find('td.template-number').data('partidentifier');

        // Highlight this specific tr and remove other highlights
        oThis.addClass('active').siblings().removeClass('active');

        // Highlight selected parts
        $.each(oMap.find('a.template-coords'), function (i) {
            var oItem = $(this);
            if (oItem.data('partidentifier') == iPartNumber) {
                oItem.addClass('active');
            } else if (oItem.hasClass('active') && oItem.data('partidentifier') != iPartNumber) {
                oItem.removeClass('active');
            }
        });
    });

    // Highlight item in table when selected in image map
    $('#assembly_drawing_map').on('click', 'a', function (e) {
        var oThis = $(this);
        $.each($('#assembly-parts-table tbody.assembly-parts-list').find('tr'), function (i) {
            var tmpRow = $(this);

            // Find the corresponding table row and trigger its click function and then end(only 1 tablerow)
            if ($(this).find('td.template-number').data('partidentifier') == oThis.data('partidentifier')) {
                tmpRow.trigger('click');
                return;
            }
        });

        e.preventDefault();
    });

    // Load Assembly Drawing when clicking component drawing
    $('#assembly_drawing_container a').not(".partsCatalog").on('click', loadAssemblyDrawing);

    function loadAssemblyDrawing(e) {
        var iMYBE = $(this).data('mybe'),
            iIllustrationId = $(this).data('illustrationid'),
            iPageId = $(this).data('pageid'),
            iLang = $(this).data('lang'),
			oAssemblyDetailsContainer = $('#assembly_drawing_details');

        // Toggle Display of ajax container and result
        if (oAssemblyDetailsContainer.hasClass('hidden')) {
            // First Time Activating
            oAssemblyDetailsContainer.removeClass('hidden');
        } else {
            // In case there was an error last time
            oAssemblyDetailsContainer.find('div.template-ajax-error').addClass('hidden');
            oAssemblyDetailsContainer.find('div.template-ajax-result').removeClass('hidden');
            // Toggle loading and result container
            oAssemblyDetailsContainer.find('div.template-ajax-result, div.template-ajax-loading').toggleClass('hidden');
        }
        // Scroll to results
        oAssemblyDetailsContainer[0].scrollIntoView(true);

        $.ajax({
            url: '/parts/partDetails/GetAssemblyDrawingParts',
            data: { MYBE: iMYBE, IllustrationId: iIllustrationId, PageId: iPageId, Lang: iLang },
            dataType: 'json',
            success: function (data) {
                var oExplodedView = $('#assembly_drawing_exploded_view'),
					oDrawing = $('#assembly_drawing_exploded'),
					oMap = $('#assembly_drawing_map'),
					oMapAreaTemplate = oMap.find('a.template-coords.hidden'),
					oParts = data.assembly_drawing.parts,
					oAssemblyPartsList = oAssemblyDetailsContainer.find('tbody.assembly-parts-list'),
					oItemTemplate = oAssemblyPartsList.find('tr.template-item.hidden'),
                    oAssemblyDrawingBuyDesc = $('#assembly_drawing_buy_desc'),
                    oAssemblyDrawingBuyHeading = $('#assembly_drawing_buy_heading');

                // Update Title / Image
                oAssemblyDetailsContainer.find('h3').text(data.assembly_drawing.title);
                // This is written this way for IE8 support, it fails if it loads the 'same' resource so append date/time
                oDrawing.bind('load', function () {
                    oDrawing.removeAttr('width');
                    oDrawing.data('zoom1width', oDrawing.width() * .5).attr('width', oDrawing.data('zoom1width'));
                }).attr('src', data.assembly_drawing.image + '?' + new Date().getTime());

                // Clear previous results if any
                oMap.find('a.template-coords:not(.hidden)').remove();
                oAssemblyPartsList.find('tr.template-item:not(.hidden)').remove();

                // Cycle through the parts and append to the list table
                $.each(oParts, function (i) {
                    var tmpItem = oItemTemplate.clone().removeClass('hidden');

                    // Update Number
                    tmpItem.find('td.template-number').data('partidentifier', oParts[i].partidentifier).prepend(oParts[i].partidentifier);

                    // Update Footnote
                    if (oParts[i].footnote !== null && oParts[i].footnote != "") {
                        tmpItem.find('td.template-number').find('a').attr('title', oParts[i].footnote).removeClass('hidden');
                    }

                    // Update Description                 
                    if (oParts[i].superceded !== null && oParts[i].superceded != "") {
                        tmpItem.find('td.template-description').html(oParts[i].number + "<br />" + oParts[i].description
                            + "<br><span class='small'><span class='fa fa-info-circle text-primary'></span> Replaces " + oParts[i].superceded + "</span>");
                    } else {
                        tmpItem.find('td.template-description').html(oParts[i].number + "<br />" + oParts[i].description);
                    }

                    //Update Quantity
                    tmpItem.find('td.template-quantity').html(oParts[i].quantity);

                    //Update Price
                    tmpItem.find('span.template-price').html(oParts[i].price);

                    // Update Buy Parameters
                    if (oParts[i].buy_url !== null && oParts[i].buy_url != "" && oParts[i].price !== null && oParts[i].price != "") {
                        tmpItem.find('td.template-buy').find('a').attr('href', oParts[i].buy_url);
                        oAssemblyDrawingBuyDesc.removeClass('hidden');
                        oAssemblyDrawingBuyHeading.removeClass('hidden');
                    } else {
                        tmpItem.find('td.template-buy').find('a').addClass('hidden');
                    }


                    // Cycle through this part's coordinates
                    if (oParts[i].coords !== undefined) {
                        $.each(oParts[i].coords, function (j) {
                            var tmpAreaMap = oMapAreaTemplate.clone().removeClass('hidden'),
								oZoom1x = oParts[i].coords[j].zoom1x.split(','),
								oZoom2x = oParts[i].coords[j].zoom2x.split(',');

                            // Calculate the position and dimensions of each coordinate and store for future use
                            tmpAreaMap.data({
                                'partidentifier': oParts[i].partidentifier,
                                'zoom1x': oParts[i].coords[j].zoom1x,
                                'zoom2x': oParts[i].coords[j].zoom2x,
                                'zoom1x-style': 'top: ' + oZoom1x[1] + 'px;left: ' + oZoom1x[0] + 'px;width: ' + (oZoom1x[2] - oZoom1x[0]) + 'px;height: ' + (oZoom1x[3] - oZoom1x[1]) + 'px;',
                                'zoom2x-style': 'top: ' + oZoom2x[1] + 'px;left: ' + oZoom2x[0] + 'px;width: ' + (oZoom2x[2] - oZoom2x[0]) + 'px;height: ' + (oZoom2x[3] - oZoom2x[1]) + 'px;'
                            }).attr({
                                'href': '#partidentifier' + oParts[i].partidentifier,
                                'style': tmpAreaMap.data('zoom1x-style')
                            }).show();

                            // Append area to map
                            tmpAreaMap.appendTo(oMap);
                        });
                    } else {
                        // There are no coordinates therefore it is not listed
                        tmpItem.find('td.template-number .fa').removeClass('hidden');
                    }

                    // Append part to table
                    tmpItem.appendTo(oAssemblyPartsList);
                });

                // Enable Tooltips
                oAssemblyPartsList.find('td.template-number .fa:not(.hidden)').tooltip({ 'placement': 'right', });

                // Toggle loading and result container
                oAssemblyDetailsContainer.find('div.template-ajax-result, div.template-ajax-loading').toggleClass('hidden');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                oAssemblyDetailsContainer.find('div.template-ajax-error > div.alert').html(errorThrown);
                oAssemblyDetailsContainer.find('div.template-ajax-loading, div.template-ajax-error').toggleClass('hidden');
            }
        });

        e.preventDefault();
    }

    //---------------------------------------------------------------
    // Misc Functions
    //---------------------------------------------------------------
    // Pause carousel when modal window is displayed
    $('.modal').on('shown.bs.modal', function (e) {
        $('.carousel').carousel('pause');
    });

    // Play carousel when modal window is closed
    $('.modal').on('hide.bs.modal', function (e) {
        $('.carousel').carousel('cycle');
    });

    // Refresh video src to stop playing if user closes/hides modal w/o stopping video
    $(".toro-video").on("hidden.bs.modal", function () {
        var currentVideo = $(this).find('iframe');
        if (currentVideo != undefined) {
            currentVideo.attr('src', currentVideo.attr('src'));
        }
    });

    // Video Modal
    $('.media-thumb[data-target=".toro-video"]').click(function (z) {
        z.preventDefault();
        var zTarget = $(this).data('target'),
            zTitle = $(this).attr('title'),
             zVideo = $(this).data('video');
        $(zTarget).find('iframe').attr('src', zVideo);
        $(zTarget).find('.modal-header .modal-title').html(zTitle);
    });

    // Image Modal
    $('.media-thumb[data-target=".image-modal"]').click(function (z) {
        z.preventDefault();
        var zTarget = $(this).data('target'),
            zTitle = $(this).attr('title'),
            zImage = $(this).data('image');
        $(zTarget).find('.modal-header .modal-title').html(zTitle);
        $(zTarget).find('.modal-body').html('<img class="center-block img-responsive img-rounded" src="' + zImage + '" alt="' + zTitle + '"/>');
    });

    /* Thumb Carousel --------------------------------------------------*/
    $(".thumb-indicators .thumb").on("click", function () {
        var currentVideo = $(".detail_carousel .active iframe");
        $(".thumb-indicators .thumb").removeClass("active");
        $(this).addClass("active");
        // Reload Video
        if (currentVideo != undefined) {
            currentVideo.attr('src', currentVideo.attr('src'));
        }
    });

    /* Side Bar / Side Nav ------------------------------------------*/
    /*Not using because of bug where scrollspy skips sections that aren't large enough to take up display space */
    //$('body').scrollspy({
    //    target: '.side-bar'
    //})

    /* Hide Back and Next arrows */
    /*
    checkitem = function() {
          var $this;
          $this = $("#thumbcarousel");
          if ($("#thumbcarousel .carousel-inner .item:first").hasClass("active")) {
            $this.children(".left").hide();
            $this.children(".right").show();
          } else if ($("#thumbcarousel .carousel-inner .item:last").hasClass("active")) {
            $this.children(".right").hide();
            $this.children(".left").show();
          } else {
            $this.children(".carousel-control").show();
          }
        };
    
        checkitem();
    
        $("#thumbcarousel").on("slid.bs.carousel", "", checkitem);
    
    });*/



    // Custom Switch Tab control with inputs instead of tabs
    /*
    $('input.toro-tab-switch').click(function() {
        $(this).tab('show');
    });
	*/

    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////
    //---------------------------------------------------------------
    // Product Category Filters and Product Listing
    //---------------------------------------------------------------
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////
    var productListId = $("input#hdnProductListId").attr("value");
    var productFilterStyleType = "";
    var productFilterListPrice = new Array();
    var productFilterSmartFeature = new Array();
    var productFilterEngine = new Array();
    var productFilterLotSize = new Array();
    var productFilterTerrain = new Array();
    var productFilterCuttingDeckSize = new Array();
    var productFilterCuttingDeckType = new Array();
    var productFilterSeatSize = new Array();
    var productFilterConstruction = new Array();

    // Product style radio buttons when clicked upon
    $('input[id*=product_style_radio]').on('click', function (e) {
        productFilterStyleType = $(this).attr('data-ajax');
        getProducts();
    });

    // Product style radio buttons when clicked upon
    $('label[id*=product_style_label]').on('click', function (e) {
        productFilterStyleType = $(this).attr('data-ajax');
        getPopeProducts();
    });

    // When product filter checkboxes are applied
    $('a[data-product-filter-category]').on('click', function (e) {
        // Reset filter variables
        productFilterListPrice.length = 0;
        productFilterSmartFeature.length = 0;
        productFilterEngine.length = 0;
        productFilterLotSize.length = 0;
        productFilterTerrain.length = 0;
        productFilterCuttingDeckSize.length = 0;
        productFilterCuttingDeckType.length = 0;
        productFilterSeatSize.length = 0;
        productFilterConstruction.length = 0;

        // Get the category for the filter
        var productFilterCategory = $(this).attr('data-product-filter-category');

        // Get the current checked filters
        var filters = $("input:checkbox[data-product-filter-category=" + productFilterCategory + "]:checked");

        if (filters.length > 0) {
            // Loop through and add value to array
            filters.each(function () {
                var productFilterValue = $(this).val();
                var productFilterOptions = $("span[data-filter-options=" + productFilterCategory + "]");

                // Set the filters for AJAX call to get products
                setFilter(productFilterCategory, productFilterValue, productFilterOptions);
            });

            // Reset the tab to product style
            $("li#product-filters").removeClass("active");
            $("li#product-styles").addClass("active");
            $("div[data-tab-category=" + productFilterCategory + "]").removeClass("active");
            $("div#tab-product_styles").addClass("active");
            $("li#" + productFilterCategory + "").removeClass("active");

            // Show the applied filters button with selections
            $("button#applied-filter-button[data-filter-button=" + productFilterCategory + "]").show();
            $('div#applied-filters-container').show();

            // Get and render the products
            getProducts();
        }
        else {
            // Reset the tab to product style
            $("li#product-filters").removeClass("active");
            $("li#product-styles").addClass("active");
            $("div[data-tab-category=" + productFilterCategory + "]").removeClass("active");
            $("div#tab-product_styles").addClass("active");
            $("li#" + productFilterCategory + "").removeClass("active");

            // Clear the applied filter options
            $("span[data-filter-options=" + productFilterCategory + "]").text("");

            // Hide the applied filters button with selections
            $("button#applied-filter-button[data-filter-button=" + productFilterCategory + "]").hide();
            $('div#applied-filters-container').hide();
        }
    });

    // When button itself is clicked on invidually
    $("button#applied-filter-button").click(function () {
        // Get the category for the filter
        var productFilterCategory = $(this).attr('data-filter-button');

        // Remove text from applied filter and reset filter variable
        $("span[data-filter-options=" + productFilterCategory + "]").text("");
        var filter = getFilter(productFilterCategory);
        filter.length = 0;

        // Get the current checked filters
        var filters = $("input:checkbox[data-product-filter-category=" + productFilterCategory + "]:hidden:checked");

        // Loop through the checkboxes for that category and uncheck
        filters.each(function () {
            $(this).attr('checked', false);
        });

        // Hide the button
        $(this).hide();

        // Reset the selection in the dropdown to not active
        $("li#" + productFilterCategory + "").removeClass("active");

        // If last button for applied filters then close the applied filters container
        var buttonCount = 0;

        $('div#applied-filters').children().each(function (index) {
            var filterCategory = $(this).attr('data-filter-button');

            // If element is a button element 
            if (filterCategory) {
                buttonCount++;
            }
        });

        if ($('div#applied-filters').children(':hidden').length == buttonCount) {
            $('div#applied-filters-container').hide();
        }

        // Get and render the products
        getProducts();
    });

    // When the clear all button is clicked on
    $('a#applied-filters-clear').on('click', function (e) {
        // Reset filter variables
        productFilterListPrice.length = 0;
        productFilterSmartFeature.length = 0;
        productFilterEngine.length = 0;
        productFilterLotSize.length = 0;
        productFilterTerrain.length = 0;
        productFilterCuttingDeckSize.length = 0;
        productFilterCuttingDeckType.length = 0;
        productFilterSeatSize.length = 0;
        productFilterConstruction.length = 0;

        $('div#applied-filters').children().each(function (index) {
            var filterCategory = $(this).attr('data-filter-button');

            // If element is a button element 
            if (filterCategory) {
                $("span[data-filter-options=" + filterCategory + "]").text("");
                $(this).hide();
            }
        });

        // Hide the applied filters container
        $('div#applied-filters-container').hide();

        // Reset product styles tab
        $("div#tab-product_styles").addClass("active");
        $("li#product-styles").addClass("active");

        // Reset the selections in the dropdown to not active
        $("ul#product-filters").children().each(function (index) {
            $(this).removeClass("active");
        });

        // Get ALL the checked filters
        var filters = $("input:checkbox[data-product-filter-category]:hidden:checked");

        // Loop through the checkboxes and uncheck
        filters.each(function () {
            $(this).attr('checked', false);
        });

        // Remove text from applied filter and reset productFilterListPrice variable
        $("span[data-filter-options]").text("");

        // Get and render the products
        getProducts();
    });

    function setFilter(productCategoryFilter, productFilterValue, productFilterOptions) {
        // Put value in array variable for AJAX call to get products
        // Reset and set text in applied filter
        var filter = getFilter(productCategoryFilter);

        if (productCategoryFilter == "price") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "smart-feature") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "engine") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "lot-size") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "terrain") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "cutting-deck-size") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "cutting-deck-type") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "seat-size") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
        else if (productCategoryFilter == "construction") {
            populateFilter(filter, productFilterValue, productFilterOptions);
        }
    }

    function populateFilter(filter, productFilterValue, productFilterOptions) {
        // Put value in array variable for AJAX call to get products
        // Reset and set text in applied filter
        filter.push(productFilterValue);
        productFilterOptions.text(filter.join(", "));
    }

    function getFilter(productCategoryFilter) {
        // Get the filter based on the item title in the filter item
        // Name will need to be exact match to correlate 
        if (productCategoryFilter == "price") {
            return productFilterListPrice;
        }
        else if (productCategoryFilter == "smart-feature") {
            return productFilterSmartFeature;
        }
        else if (productCategoryFilter == "engine") {
            return productFilterEngine;
        }
        else if (productCategoryFilter == "lot-size") {
            return productFilterLotSize;
        }
        else if (productCategoryFilter == "terrain") {
            return productFilterTerrain;
        }
        else if (productCategoryFilter == "cutting-deck-size") {
            return productFilterCuttingDeckSize;
        }
        else if (productCategoryFilter == "cutting-deck-type") {
            return productFilterCuttingDeckType;
        }
        else if (productCategoryFilter == "seat-size") {
            return productFilterSeatSize;
        }
        else if (productCategoryFilter == "construction") {
            return productFilterConstruction;
        }
    }

    function getPopeProducts() {
        // Take the product variables and make an AJAX post to get the products
        var product = {
            ProductListId: productListId,
            ProductFilterStyleType: productFilterStyleType,
            ProductFilterListPrice: productFilterListPrice,
            ProductFilterSmartFeature: productFilterSmartFeature,
            ProductFilterEngine: productFilterEngine,
            ProductFilterLotSize: productFilterLotSize,
            ProductFilterTerrain: productFilterTerrain,
            ProductFilterCuttingDeckSize: productFilterCuttingDeckSize,
            ProductFilterCuttingDeckType: productFilterCuttingDeckType,
            ProductFilterSeatSize: productFilterSeatSize,
            ProductFilterConstruction: productFilterConstruction
        };
        $('.template-ajax-loading').show();
        $.ajax({
            type: "POST",
            url: "/ProductList/GetPopeProducts",
            data: JSON.stringify(product),
            contentType: 'application/json',
            dataType: 'html',
            success: function (data) {
                var productList = $('div[data-method=getProducts]');
                productList.html(data);
                getResultCount();
                $('.template-ajax-loading').hide();
            }
        });
    }

    function getProducts() {
        // Take the product variables and make an AJAX post to get the products
        var product = {
            ProductListId: productListId,
            ProductFilterStyleType: productFilterStyleType,
            ProductFilterListPrice: productFilterListPrice,
            ProductFilterSmartFeature: productFilterSmartFeature,
            ProductFilterEngine: productFilterEngine,
            ProductFilterLotSize: productFilterLotSize,
            ProductFilterTerrain: productFilterTerrain,
            ProductFilterCuttingDeckSize: productFilterCuttingDeckSize,
            ProductFilterCuttingDeckType: productFilterCuttingDeckType,
            ProductFilterSeatSize: productFilterSeatSize,
            ProductFilterConstruction: productFilterConstruction
        };
        $('.template-ajax-loading').show();
        $.ajax({
            type: "POST",
            url: "/ProductList/GetProducts",
            data: JSON.stringify(product),
            contentType: 'application/json',
            dataType: 'html',
            success: function (data) {
                var productList = $('div[data-method=getProducts]');
                productList.html(data);
                getResultCount();
                $('.template-ajax-loading').hide();
            }
        });
    }

    function getResultCount() {
        var hdnResultCountAjax = $("input#hdnResultCountAjax").first().attr("value");
        $("span.total_results").text(hdnResultCountAjax);
    }

    $('#thumb-carousel').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
              breakpoint: 992,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  infinite: true,
                  dots: true
              }
          },
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          }
        ]
    });
    //SET BOOTSTRAP CAROUSEL INTERVAL TO 5 SECONDS
    //SET HOVER PAUSE TO FALSE
    var myCarousel = $("#main-carousel");
    $(myCarousel).carousel({
        interval: 5000
    });

    myCarousel.on("slide.bs.carousel", function (event) {
        var $currentSlide = myCarousel.find(".active iframe");

        // exit if there's no iframe, i.e. if this is just an image and not a video player
        if (!$currentSlide.length) { return; }
        player.pauseVideo();

        //For Vimeo Videos, pass that iframe into Froogaloop, and call api("pause") on it.
        //var player = Froogaloop($currentSlide[0]);
        //player.api("pause");
    });
});

//-----------------------------------------------------------------------------------------
// Carousel
//-----------------------------------------------------------------------------------------

var tag = document.createElement('script');
tag.id = 'iframe-video';
tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
var videoStatus;

function onYouTubeIframeAPIReady() {
    player = new YT.Player('player', {
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
    });
}

//Player Controls
function playVideo() { player.playVideo(); }
function pauseVideo() { player.pauseVideo(); }
function stopVideo() { player.stopVideo(); }

function onPlayerReady(event) {
    document.getElementById('player');
    //playVideo();
}

function onPlayerStateChange(event) {
    changeStatus(event.data);
    console.log(videoStatus);
}

function changeStatus(playerStatus) {
    if (playerStatus == -1) {
        videoStatus = 'unstarted';
        //$('#main-carousel').carousel('pause');
    } else if (playerStatus == 0) {
        videoStatus = 'ended';
        $('#main-carousel').carousel('next');
    } else if (playerStatus == 1) {
        videoStatus = 'playing';
        $('#main-carousel').carousel('pause');
    } else if (playerStatus == 2) {
        videoStatus = 'paused';
        $('#main-carousel').carousel('cycle');
    } else if (playerStatus == 3) {
        videoStatus = 'buffering';
    } else if (playerStatus == 5) {
        videoStatus = 'video cued';
    }
}
//Modal Lightbox
$(document).delegate('*[data-toggle="lightbox"]', 'click', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox();
});